import script from "./news.vue?vue&type=script&setup=true&lang=js"
export * from "./news.vue?vue&type=script&setup=true&lang=js"

import "./news.vue?vue&type=style&index=0&id=7bca6c0d&lang=scss"

const __exports__ = script;

export default __exports__